export default `
<h3 style="text-align: justify;"><b>La década del 20. Clase media y
        revolución de la publicidad.</b></h3>
<p class="western" style="text-align: justify;">Después de la Primera
    Guerra Mundial y como consecuencia de la nueva configuración política
    del planeta, entró en crisis el liberalismo clásico, dominante en las
    décadas anteriores. La jerarquía de las potencias internacionales se
    modificó y los Estados latinoamericanos que subsistían gracias a una
    economía agraria exportadora
    <!-- Acordate lo que charlábamos en clase respecto de relativizar la idea de “modelo” -->,
    que muchas veces se centraba en un solo producto o mercado, debieron
    adaptarse a nuevos requerimientos. Por otro lado, la expansión del
    consumo, especialmente en las capas medias de la sociedad, le dio otra
    apariencia al mercado.</p>
<h3 style="text-align: justify;"><b>Expansión de la clase media:</b></h3>
<p style="text-align: justify;"><span style="font-weight: 400;"><img style="width: 372px; height: 158px;"
            class="wp-image-76 alignleft" src="https://consumoenargentina.files.wordpress.com/2018/09/clasemedia1.png"
            alt="clasemedia" align="left" hspace="5">El proyecto de país puesto en
        marcha se tradujo en un crecimiento desigual que hizo la estructura
        social más compleja. Conformada por profesionales, comerciantes,
        propietarios de chacras, empleados de la administración pública y
        privada que fueron constituyendo sectores cada vez más amplios de la
        población, la llamada clase media vivió una gran expansión en este
        periodo debido a varios factores, uno de ellos era que quienes
        trabajaban en empresas públicas o privadas, particularmente los bancos,
        no realizaban tareas manuales, sino intelectuales, y se veían a sí
        mismos como miembros de una clase diferente que no era la obrera, ni
        tampoco la popular. Por otro lado, como percibían salarios más altos,
        estos empleados compraban más y mejores ropas, productos de tocador,
        aparatos eléctricos para la casa, radios, muebles, libros y revistas.
        También gastaban en diversiones en sus momentos de ocio, como el teatro
        y el cine. Estas dos cuestiones, dinero y necesidad de diferenciación
        (recordemos "consumo conspicuo") son los ingrediente esenciales para
        que surja una sociedad de consumo.</span></p>
<p style="text-align: justify;"><span lang="es-AR">Según venimos
        planteando, el consumo cumple dos funciones, una de diferenciación
        social y otra como mecanismo movilizador de vastos sectores de la
        economía, lo cual creaba a su vez fuentes de trabajo y posibilidades de
        ascenso social. Sin embargo, estas ventajas materiales no beneficiaron
        a todos por igual, ni llegaron a todos los grupos sociales. Los pueblos
        originarios, por ejemplo, perdieron su libertad para ser sometidos como
        fuerza de trabajo en explotaciones agrícolas y a los gauchos y
        campesinos se les comenzó a dificultar el acceso a las parcelas de
        tierra, que se fueron concentrando en menos manos.</span></p>
<h2>&nbsp;</h2>
<h2 style="text-align: justify;"><b>Nuevas estrategias de llegada al
        consumidor.</b></h2>
<h3 style="text-align: justify;"><b>Llegan las agencias publicitarias.</b></h3>
<p style="text-align: justify;"><span lang="es-AR">Ante esa
        complejización de la sociedad, el mercado de consumidores logró un gran
        crecimiento y las firmas productoras redoblaron sus esfuerzos para
        acercarse buscando nuevas estrategias de comercialización. La gran
        novedad fue la aparición de las agencias publicitarias que,
        provenientes de otros mercados en desarrollo como EEUU, eran compañías
        especializadas en diseño y venta de de publicidad
        <!-- Ya pusiste estrategia en el renglón anterior -->.
        Éstas comenzaron actuando de intermediarias entre las firmas y la
        prensa, ofreciendo la colocación de avisos de manera mayorista en
        diarios y revistas, para luego ir sumando funciones y servicios, como
        el diseño artístico y la creatividad para la elaboración de los
        mensajes. Los planteles de trabajo de las agencias se ampliaron
        incluyendo escritores, dibujantes y agentes de venta, la mayoría de
        ellos extranjeros.</span></p>
<p style="text-align: justify;">A su vez las agencias comenzaron a
    hacer uso de disciplinas científicas como la psicología y la sociología
    para mejorar la comprensión de las necesidades del público. Algunas
    también se dedicaron a desarrollar el envío de publicidades a través
    del correo postal, cosa que ofrecía a las firmas productoras la
    posibilidad de ampliar su público fuera de las grandes ciudades. Debido
    a la promesa de desarrollo que proponían la economía y el mercado en la
    Argentina, éste fue el primer país de América Latina donde las agencias
    publicitarias decidieron establecerse. A estas primeras agencias
    extranjeras se sumaron luego algunas firmas de origen local,
    conformándose así un dinámico campo profesional que pronto contó con
    revistas especializadas y vida propia.</p>
<p><br>
</p>
<h3 style="text-align: justify;"><b>Las calles como espacios
        publicitarios.</b></h3>
<p style="text-align: justify;">El desarrollo de publicidades visuales
    en la vía pública se incrementó mucho durante la década del 20. En
    Buenos Aires surgieron incluso inquietudes por parte del gobierno
    acerca de la contaminación visual debido a la concentración excesiva de
    avisos que se constataba en las calles más importantes. De capital
    importancia fue la evolución del rol de la mujer en las estrategias
    publicitarias, ya que si bien continuó sirviendo como modelo, también
    se convirtió en público consumidor y fue la puerta de entrada a la
    intimidad de la esfera familiar. Los anuncios comenzaron a orientarse
    cada vez más hacia el público femenino mediante productos de moda,
    ropa, cámaras fotográficas y otros bienes.</p>
<h3 style="text-align: justify;"><b>La llegada del cine</b></h3>
<iframe width="420" height="315"
src="https://www.youtube.com/watch?v=OiN4w5Ugpsg">
</iframe>
<p style="text-align: justify;"><span lang="es-AR">A la publicidad
        impresa y a la callejera se sumó un nuevo vehículo de transmisión
        cultural que fue el cine. Ya en 1900 se había abierto la primera sala
        en Buenos Aires y pronto se expandió a otras ciudades del interior como
        Mendoza, Rosario y Mar del Plata. Estas primeras proyecciones eran
        mudas, aunque por lo general incluían algún tipo de acompañamiento
        sonoro, como música en vivo o relatores que comentaban lo que iba
        sucediendo en la pantalla. En la década del 20 se produjo una verdadera
        explosión de salas, llegando a registrarse hasta 102 aperturas de las
        mismas solo en la ciudad de Buenos Aires, comparadas con las 4 que
        había en la década anterior y las 51 de los años 30.<br>
        En esta etapa se comenzó a experimentar con las posibilidades que el
        nuevo medio otorgaba y se realizaron noticieros y documentales basados
        en la historia y la literatura. En 1917 se realizó el primer
        largometraje nacional de dibujos animados sobre la figura de Hipólito
        Irigoyen, siendo el resto de las películas material importado del
        hemisferio norte.<br>
        Así, los espectadores fueron incorporando la asistencia a salas de cine
        como otra de las actividades propias del tiempo libre y, sumado a las
        mejoras en su calidad, este pasatiempo cautivaría cada vez más público
        en los años siguientes. Debido a esta incorporación del cine a la
        esfera de consumo, las empresas productoras de bienes aprovecharon la
        oportunidad para utilizar las salas de cine y proyecciones como vitrina
        para mostrar las bondades de sus productos. El historiador Fernando
        Rocchi ha destacado el caso de la “Compañía General de Fósforos”, que
        exhibía una película de propaganda llamada “La cajita mágica”, que
        resultó en un importante incremento en la venta del producto.</span></p>
<p style="text-align: center;"><img class="alignnone size-full wp-image-181"
        src="https://consumoenargentina.files.wordpress.com/2018/09/biblio-132.png" alt="biblio-132" height="363"
        width="794"></p>
`